import { Environment } from "./environment.model";

export const environment: Environment = {
  configFile: "assets/config/production.json",
  production: true,
  applicationVersion: "2025-07-02#83aa065",
  providers: [],
};
